'use strict';

import angular from 'angular';

export default function f($http, utils, userModel) {
  'ngInject';

  return {

    /*
      analyticsSa.track({
         action: '',
         data: {}
      });
    */
    track(data) {
      data.data = angular.extend(data.data, {pricePoint: userModel.item.membership.price});
      $http.post(utils.getApiUrlV2('analytics/'), data);
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/analytics_sa.js